/**
 * Struktura s lokalizovanými texty pro konkrétní lokalizační klíc
 * @includeToDoc
 */
export interface ILocalizationItem {
    /** Jazyk lokalizace (např. 'EN' nebo 'CZ') */
    readonly language: string;
    /** Lokalizační klíč obsahující jak oblast, tak číslo (např. XX-12345) */
    readonly locKey: string;
    /** Text primárního překladu */
    readonly primaryText: string;
    /** Text sekundární překladu. Často obsahuje podrobnější popis a používá se například pro vysvětlující popisky a jako alternativní text */
    readonly secondaryText?: string;
}
